import { TRoutes } from "../routes.types";

export const adminPortal = {
} satisfies TRoutes;
